import React from 'react';
import Page from '../../components/Page/Page';
import { Col, Empty, Row, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import CareemTechnicalErrorIcon from '../../assets/img/careemTechnicalErrorIcon.svg?react';
import { useTranslation } from 'react-i18next';
import styles from './EmptyPage.module.less';
import Button from '../../components/Button/Button';

export enum EMPTY_PAGE_USECASE {
  PAGE_NOT_FOUND = 'PAGE_NOT_FOUND',
  ACCOUNT_DISABLED = 'ACCOUNT_DISABLED',
  ACTIVE_EMPTY = 'ACTIVE_EMPTY',
  COMPLETED_EMPTY = 'COMPLETED_EMPTY',
  ADDRESSES_EMPTY = 'ADDRESSES_EMPTY'
}

const getIcon = (useCase: EMPTY_PAGE_USECASE) => {
  switch (useCase) {
    case EMPTY_PAGE_USECASE.ACCOUNT_DISABLED:
      return <CareemTechnicalErrorIcon style={{ height: '185px', width: '285px' }} />;
    case EMPTY_PAGE_USECASE.PAGE_NOT_FOUND:
    case EMPTY_PAGE_USECASE.ACTIVE_EMPTY:
    case EMPTY_PAGE_USECASE.COMPLETED_EMPTY:
    default:
      return Empty.PRESENTED_IMAGE_DEFAULT;
  }
};

type EmptyPageProps = {
  useCase: EMPTY_PAGE_USECASE;
  hasCTA?: boolean;
  ctaAction?: () => void;
};

const EmptyPage = ({ useCase, hasCTA, ctaAction }: EmptyPageProps): React.ReactElement => {
  const { t } = useTranslation();
  const componentIcon = getIcon(useCase);
  return (
    <Page>
      <Row className={styles.rowNotFoundText}>
        <Col className={styles.container}>
          <Empty
            image={componentIcon}
            imageStyle={{ height: 185 }}
            description={
              <>
                <Row align="middle">
                  <Col span={24}>
                    <Typography.Title level={3}>{t(`emptyPage.${useCase}.title`)}</Typography.Title>
                  </Col>
                  <Col span={24}>
                    <div>
                      <Typography.Text type="secondary">{t(`emptyPage.${useCase}.message`)}</Typography.Text>
                    </div>
                  </Col>
                  {hasCTA && ctaAction && (
                    <Col span={24}>
                      <Button
                        icon={<PlusOutlined />}
                        className={styles.callToActionBtn}
                        size={'large'}
                        type="primary"
                        onClick={ctaAction}
                      >
                        {t(`emptyPage.${useCase}.ctaText`)}
                      </Button>
                    </Col>
                  )}
                </Row>
              </>
            }
          />
        </Col>
      </Row>
    </Page>
  );
};

export default EmptyPage;
